import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'TTS',
      component: () => import('@/views/TtsView.vue'),
    },
    {
      path: '/gemini-tts',
      name: 'GeminiTTS',
      component: () => import('@/views/TtsGeminiView.vue'),
    },
  ],
});

export default router;